<div class="container">
    <h3 class="title">{{headerMessage}}</h3>
    <dxo-card>
        <card-body>
            <div id="letter-card">                
                <div>
                    <p class="info">
                        To access and engage in the self-service portal, you must agree with the following:                       
                    </p>
                    <div *ngIf="!termsConditions">
                        <p>
                            <a class="download-link" target="blank" href={{termsCondistionsPath}}>Terms & Conditions<dxo-icon color="currentColor" [right]="true"> open_in_new </dxo-icon></a>
                        </p>
                    </div>
                    <div  *ngIf="!electronicConsent">
                        <p>
                            <a class="download-link"target="blank" href={{electronicConsentPath}}>Electronic Consent & Disclosure Agreement<dxo-icon color="currentColor" [right]="true"> open_in_new </dxo-icon></a>
                        </p>
                    </div>
                    <div>
                        <dxo-button class="disgree-button" (handleClick)="onDisagree()" text="I disagree"></dxo-button>
                        <dxo-button [primary]="true" (handleClick)="onAgree()" text="I agree"></dxo-button>
                    </div>
                </div>
            </div>
        </card-body>
    </dxo-card>
</div>